import styled from '@emotion/styled';
import ContentCard from '../content-card';

export const SadaAppointmentCard = styled(ContentCard)``;
